import { ResourceEnum, RoutePaths } from "config";

export const assistantPages = [
  { page: RoutePaths.QUANT_ALERTS, resource: ResourceEnum.QuantAlerts },
  {
    page: RoutePaths.QUANT_DASHBOARD,
    resource: ResourceEnum.QuantTradingPerformanceAccount,
  },
  {
    page: RoutePaths.QUANT_ACCOUNTS,
    resource: ResourceEnum.QuantTradingPerformanceAccount,
  },
  {
    page: RoutePaths.FINANCE_ASSETS_EXCHANGE_ACCOUNTS,
    resource: ResourceEnum.AssetsExchange,
  },
  {
    page: RoutePaths.INFRASTRUCTURE_SYSTEM_TASKS,
    resource: ResourceEnum.InfrastructureSystemTask,
  },
  {
    page: RoutePaths.HR_FINANCIAL_REPORT,
    resource: ResourceEnum.HrFinancialReport,
  },
  {
    page: RoutePaths.HR_POINT_SYSTEM_QUANT_FUND_TIER,
    resource: ResourceEnum.HrQuantFundTier,
  },
  {
    page: RoutePaths.HR_POINT_SYSTEM_QUANT_POINTS,
    resource: ResourceEnum.HrQuantPoints,
  },
  {
    page: RoutePaths.HR_POINT_SYSTEM_QUANT_PERFORMANCE,
    resource: ResourceEnum.HrQuantPerformance,
  },
  {
    page: RoutePaths.HR_POINT_SYSTEM_QUANT_DISTRIBUTION,
    resource: ResourceEnum.HrQuantDistributionHistory,
  },
  {
    page: RoutePaths.HR_POINT_SYSTEM_VENTURE_POINTS,
    resource: ResourceEnum.HrVenturePoints,
  },
  {
    page: RoutePaths.HR_POINT_SYSTEM_VENTURE_PERFORMANCE,
    resource: ResourceEnum.HrVenturePool,
  },
  {
    page: RoutePaths.HR_POINT_SYSTEM_VENTURE_DISTRIBUTION,
    resource: ResourceEnum.HrVentureDistributionHistory,
  },
  {
    page: RoutePaths.HR_POINT_SYSTEM_CAPITAL_FORMATION_TIER,
    resource: ResourceEnum.HrCapitalFormationTier,
  },
  {
    page: RoutePaths.HR_POINT_SYSTEM_CAPITAL_FORMATION_DISTRIBUTION,
    resource: ResourceEnum.HrCapitalFormationDistributionHistory,
  },
  {
    page: RoutePaths.SYSTEM_TASK_MANAGEMENT_TASK,
    resource: ResourceEnum.SystemTaskManagementTask,
  },
  {
    page: RoutePaths.SYSTEM_TASK_MANAGEMENT_RECURRING_TASK,
    resource: ResourceEnum.SystemTaskManagementRecurringTask,
  },
  {
    page: RoutePaths.SYSTEM_TASK_MANAGEMENT_REMIND,
    resource: ResourceEnum.SystemTaskManagementRemind,
  },
  {
    page: RoutePaths.SYSTEM_TASK_MANAGEMENT_TASK_REPORTING,
    resource: ResourceEnum.SystemTaskManagementTaskReporting,
  },
  {
    page: RoutePaths.PERMISSION_MANAGEMENT,
    resource: ResourceEnum.AuthPermissionManager,
  },
  {
    page: RoutePaths.NOTIFICATION_SETTINGS,
    resource: ResourceEnum.NotificationSettings,
  },

  { page: RoutePaths.HOME, resource: ResourceEnum.SystemTaskManagementTask },
  { page: RoutePaths.HR_EMPLOYEE, resource: ResourceEnum.HrEmployee },
  {
    page: RoutePaths.HR_EMPLOYEE_COMPENSATION,
    resource: ResourceEnum.HrEmployeeCompensation,
  },
  {
    page: RoutePaths.HR_EMPLOYEE_LEAVE,
    resource: ResourceEnum.HrEmployeeLeave,
  },
  {
    page: RoutePaths.HR_HOLIDAY_CALENDAR,
    resource: ResourceEnum.HrHolidayCalendar,
  },
];

export const homepageResources = [
  ResourceEnum.SystemTaskManagementTask,
  ResourceEnum.SystemTaskManagementRecurringTask,
  ResourceEnum.SystemTaskManagementRemind,
];

export const ASSISTANT_QUESTION_MAX_LENGTH = 2000;

// eslint-disable-next-line spellcheck/spell-checker -- Approved assistant character name.
export const ASSISTANT_NAME = "Samwell";

export const ASSISTANT_WALKTHROUGH_QUERY_PARAM = "assistantWalkthrough";

export const ASSISTANT_POPUP_SELECTOR = ".MuiPopover-paper, .MuiPopper-root";

export const ASSISTANT_PANEL_POSITION_STORAGE_KEY = "assistantPanelPosition";
export const ASSISTANT_LAUNCHER_POSITION_STORAGE_KEY =
  "assistantLauncherPosition";

export const ASSISTANT_FEATURE_QUERY_PARAM = "assistantFeature";
